// web/src/console/sections/SystemSection.tsx
import type { JSX } from "react";
import { adminApi } from "../../lib/adminApi";
import { useConsole } from "../ConsoleContext";
import { useAsync } from "../useAsync";
import { GaugeCircle, MiniStat, ServiceCard } from "../charts";
import { CardTitle } from "../Term";
import { fmtMs } from "../format";

export function SystemSection(): JSX.Element {
  const { tick } = useConsole();
  const sys = useAsync(() => adminApi.system(), [tick]);
  const svc = useAsync(() => adminApi.services(), [tick]);
  if (sys.loading || svc.loading) return <div className="cc-skeleton" style={{ height: 200 }} />;
  if (sys.error || !sys.data) return <div className="cc-empty">加载失败。 <button className="cc-back" onClick={() => { sys.reload(); svc.reload(); }}>重试</button></div>;
  const s = sys.data;
  return (
    <>
      <div className="cc-card"><CardTitle>主机指标</CardTitle>
        <div className="cc-grid cc-grid-4">
          <GaugeCircle percent={s.cpu.percent} label="CPU" sublabel={`${s.cpu.cores} 核心`} />
          <GaugeCircle percent={s.memory.pct} label="内存" sublabel={`${s.memory.usedMB}/${s.memory.totalMB} MB`} />
          <GaugeCircle percent={s.disk.pct} label="磁盘" sublabel={`${s.disk.usedGB}/${s.disk.totalGB} GB`} />
          <div className="cc-grid-stats" style={{ gridTemplateColumns: "1fr" }}>
            <MiniStat label="运行时长" value={`${Math.round(s.process.uptimeS / 60)}m`} />
            <MiniStat label="事件循环延迟" value={fmtMs(s.process.eventLoopLagMs)} />
            <MiniStat label="数据库连接池" value={`${s.dbPool.idle}/${s.dbPool.total} 空闲 · ${s.dbPool.waiting} 等待`} />
          </div>
        </div>
      </div>
      <div className="cc-card" style={{ marginTop: 12 }}><CardTitle>服务</CardTitle>
        <div className="cc-grid cc-grid-4">
          {(svc.data ?? []).map((x) => <ServiceCard key={x.name} name={x.name} state={x.state} latencyMs={x.latencyMs} detail={x.detail} />)}
        </div>
      </div>
    </>
  );
}
